/**
 * @generated SignedSource<<6df339de693663939ea3ac02e25576a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type VisibilityStatus = "ALL" | "NONE" | "QUALIFYING";
import { FragmentRefs } from "relay-runtime";
export type useGetDurationBookingRateOptions_Booking$data = {
  readonly startSlot: {
    readonly bookingRates?: ReadonlyArray<{
      readonly rate: {
        readonly appliesToMembershipType: boolean | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly visibility: VisibilityStatus;
      };
      readonly totalDurationPrice: number | null | undefined;
    } | null | undefined> | null | undefined;
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "useGetDurationBookingRateOptions_Booking";
};
export type useGetDurationBookingRateOptions_Booking$key = {
  readonly " $data"?: useGetDurationBookingRateOptions_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetDurationBookingRateOptions_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "duration"
    },
    {
      "kind": "RootArgument",
      "name": "groupSize"
    },
    {
      "kind": "RootArgument",
      "name": "membershipTypeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetDurationBookingRateOptions_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "highestPrecedentOnly",
                  "value": false
                },
                {
                  "kind": "Literal",
                  "name": "type",
                  "value": "CUSTOMER"
                },
                {
                  "kind": "Variable",
                  "name": "visibleToMembershipTypeId",
                  "variableName": "membershipTypeId"
                }
              ],
              "concreteType": "SlotRate",
              "kind": "LinkedField",
              "name": "bookingRates",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "visibility",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "membershipTypeId",
                          "variableName": "membershipTypeId"
                        }
                      ],
                      "kind": "ScalarField",
                      "name": "appliesToMembershipType",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "duration",
                      "variableName": "duration"
                    },
                    {
                      "kind": "Variable",
                      "name": "playerCount",
                      "variableName": "groupSize"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "totalDurationPrice",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "TimeSlot",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "387d2db71091be48cd19325bf7823488";

export default node;
